<template>
  <div
    :class="[
      $style.spinner,
      fullScreen && $style.fullScreen
    ]"
    :style="styleObj"
  >
    <div
      :class="$style.bounce1"
      :style="circleStyle"
    />
    <div
      :class="$style.bounce2"
      :style="circleStyle"
    />
    <div
      :class="$style.bounce3"
      :style="circleStyle"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseLoading',
  props: {
    minHeight: {
      type: Number,
      default: 250,
    },
    color: {
      type: String,
      default: '#5b6a7c',
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styleObj() {
      return this.minHeight && !this.fullScreen
        ? { height: `${this.minHeight}px` }
        : {}
    },
    circleStyle() {
      return {
        backgroundColor: this.color,
      }
    },
  },
}
</script>

<style lang="scss" module>
  .fullScreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.2);
    z-index: 10;
  }
  .spinner {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .spinner > div {
    width: 12px;
    height: 12px;
    margin: 0 2px;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
      }
  }
</style>
